// Module
var code = "<wp-header params=\"logo: 'bad-panda-logo'\"></wp-header>\r\n<br />\r\n<br />\r\n<div class=\"centered-tile\">\r\n\r\n  <div class=\"centered-tile bottom-padding-32\">\r\n    <div class=\"bottom-padding-12 validate-email\">\r\n      <spam>Check your email for instructions.</spam>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n";
// Exports
module.exports = code;